<ag-grid-angular #orderLinesGrid *ngIf="gridOptions" class="ag-theme-vdw ag-grid-compact-view" [class.loading]="loadingForTheFirstTime" [gridOptions]="gridOptions"></ag-grid-angular>
<ag-grid-angular #exportOrderLinesGrid [gridOptions]="exportGridOptions" [rowData]="exportData" class="hidden"></ag-grid-angular>
